import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { DABInlineLoading, DABTextBoxWithSearch } from '../../components/dab';
import { episodeAction } from '../../actions/episodeAction';
import { Input } from "reactstrap";
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { getCurrentUser } from '../../services/selectors/Accounts';
import { showAlert } from '../common/functions';

interface IUserEpisodeProps {
	dispatch: Dispatch<any>;
	episodeData: any;
	userId: any;
	showSearch: any;
	title: any;
}

const EpisodeEngagement: React.SFC<IUserEpisodeProps> = ({
	dispatch, episodeData, userId, showSearch, title }) => {

	const initialInputValue = {
		userId: userId,
		pageNumber: 1,
		pageSize: 10,
		searchText : "",
		sortDirection: "desc",
		sortColumn: "Date",
	};

	const [showModal, setShowModal] = useState(false);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [frontFilter, setFrontFilet] = useState({ ...initialInputValue, isListened: true})
	const [episodeEngageList, setEpisodeEngageList] = useState([]);
	const [pageList, setPageList] = useState([1]);
	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [searchText, setSearchText] = useState("");
	// Per-checkbox in-flight tracker.
	const [pendingMeta, setPendingMeta] = useState<Map<string, { field: "isListened" | "isFavourite"; episodeId: any; newValue: boolean }>>(new Map());
	const [lastSeenEngagementTick, setLastSeenEngagementTick] = useState(0);

	// Only Admin / Community Manager can edit; "Front" view is read-only.
	const loggedInUser = getCurrentUser();
	const userRoleCodes: string =
		loggedInUser && loggedInUser.info && loggedInUser.info.roleCodes
			? loggedInUser.info.roleCodes
			: "";
	const canEditEngagement =
		title !== "Front" &&
		(userRoleCodes.includes("Admin") || userRoleCodes.includes("Community"));

	const buildKey = (episodeId: any, field: "isListened" | "isFavourite") => `${episodeId}_${field}`;

	React.useEffect(() => {
		if (title === "Front") {
			dispatch(episodeAction.episodeGetUserEngagement(frontFilter));
		} else {
			dispatch(episodeAction.episodeGetUserEngagement(filterInput));
		}
		setShowModal(true);
	}, [filterInput, frontFilter]);

	if (episodeData && episodeData.isEpisodeEngagementLoaded) {
		episodeData.isEpisodeEngagementLoaded = false;
		setShowModal(false);
		setEpisodeEngageList(episodeData.episodeEngagementData.episodeEnagements);

		var total: number = episodeData.episodeEngagementData.totalCount;
		var pList: number[] = [];
		if (total > initialInputValue.pageSize) {
			for (var i = 1; i <= (total / initialInputValue.pageSize); i++) {
				pList.push(i);
			}
			if ((total % initialInputValue.pageSize) > 0) {
				pList.push((parseInt((total / initialInputValue.pageSize).toString()) + 1));
			}
		}
		else {
			pList.push(1);
		}
		setPageList(pList);
	}

	const handleToggleEngagement = (rowIndex: number, field: "isListened" | "isFavourite", newValue: boolean) => {
		if (!canEditEngagement) {
			return;
		}
		const row: any = episodeEngageList[rowIndex];
		if (!row) {
			return;
		}
		const key = buildKey(row.episodeId, field);
		if (pendingMeta.has(key)) {
			return;
		}
		setPendingMeta(prev => {
			const next = new Map(prev);
			next.set(key, { field, episodeId: row.episodeId, newValue });
			return next;
		});
		// Optimistic local update; no refetch.
		const optimistic = (episodeEngageList as any[]).map((item, idx) =>
			idx === rowIndex ? { ...item, [field]: newValue } : item
		);
		setEpisodeEngageList(optimistic as any);
		const payload = {
			userId: userId,
			episodeId: row.episodeId,
			isListenedTo: field === "isListened" ? newValue : !!row.isListened,
			isFavorite: field === "isFavourite" ? newValue : !!row.isFavourite,
		};
		dispatch(episodeAction.episodeUpdateEngagement(payload, { field, episodeId: row.episodeId, newValue }));
	};

	// Toast on API confirmation; revert on failure.
	if (episodeData) {
		const tick: number = episodeData.engagementUpdateTick || 0;
		if (tick > lastSeenEngagementTick && episodeData.lastEngagementUpdate && episodeData.lastEngagementUpdate.meta) {
			const update = episodeData.lastEngagementUpdate;
			const meta = update.meta as { field: "isListened" | "isFavourite"; episodeId: any; newValue: boolean };
			const key = buildKey(meta.episodeId, meta.field);
			if (update.success) {
				const toastMessage =
					meta.field === "isListened"
						? meta.newValue ? "Episode marked as Listened" : "Episode unmarked as Listened"
						: meta.newValue ? "Episode added to Favorites" : "Episode removed from Favorites";
				showAlert(toastMessage, false);
			} else {
				const reverted = (episodeEngageList as any[]).map((item: any) =>
					item.episodeId === meta.episodeId ? { ...item, [meta.field]: !meta.newValue } : item
				);
				setEpisodeEngageList(reverted as any);
				showAlert("Failed to update episode engagement.", true);
			}
			setPendingMeta(prev => {
				if (!prev.has(key)) return prev;
				const next = new Map(prev);
				next.delete(key);
				return next;
			});
			setLastSeenEngagementTick(tick);
		}
	}

	const handleFilter = () => {
		setFilterInput({
			...filterInput,
			pageNumber: 1,
			pageSize: 5,
			searchText: searchText
		});
		setShowModal(true);
	};

	const handleInputChange = (event) => {
		setSearchText(event.target.value);
	};

	const handlePageClick = (data) => {
		setFilterInput({
			...filterInput,
			pageNumber: data.selected + 1,
		});
		setCurrentPageNo(data.selected);
	};

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		});
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon icon={faChevronDown} />
			}
		}
	}

	const handleGetSortColumn = (display, value) => {
		return <div onClick={(e) => { handleSort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	const handleChangeCheckbox = (val) => {
		setFrontFilet({ ...frontFilter, isListened:val })
	}

	return (
		<div>
			{title != "Front" &&
				< Row >
					<Col className="verCenter">
						<h5>
							<span data-testid="episodeEngagementText">Episode Engagement</span>
						</h5>
					</Col>
					{showSearch && <>
						<Col style={{ float: "right" }}>
							<DABTextBoxWithSearch type="search" id="searchText" isRequired={false}
								onChange={(event) => { handleInputChange(event) }}
								value={searchText} onClick={(event) => { handleFilter() }}
							/>
						</Col>
					</>}
				</Row>}
			{title == "Front" && episodeEngageList && episodeEngageList.length>0 &&
				<div className='filter-row' data-testid="episodeEngagementFilter">
				<Input type="checkbox" className='box-container-input' checked={frontFilter.isListened}
					onChange={(e) => handleChangeCheckbox(e.target.checked)} />
					<span>{frontFilter.isListened ? "Listened" : "Not Listened"}</span>
				</div>}

			<table className={`table text-center ${title != "Front" ?"table-bordered":""}`} data-testid="episodeEngagementTable">
				<thead>
					<tr>
						<th data-testid="episodeEngagementDate" scope="col">{handleGetSortColumn("Date", "DATE")}</th>
						<th data-testid="episodeEngagementChannel" scope="col">Channel</th>
						<th data-testid="episodeEngagementTitle" scope="col">Title</th>
						<th data-testid="episodeEngagementListened" scope="col">Listened</th>
						{title != "Front" && <>
							<th data-testid="episodeEngagementFavorite" scope="col">Favorite</th>
							<th data-testid="episodeEngagementJournal" scope="col">Journal</th>
							<th data-testid="episodeEngagementProgress" scope="col">Progress</th></>}
					</tr>
				</thead>
				<tbody data-testid="episodeEngagementTableBody">
					{!showModal && episodeEngageList && episodeEngageList.map((data: any,index) =>
						<tr key= { "episodeEngagement" + index } >
							<td data-testid={"episodeEngagementDate" + index} key={"episodeEngagementDate" + index}>
								{moment(data.accessedDate).format("MM/DD/YYYY")}</td>
							<td data-testid={"episodeEngagementChannel" + index} key={"episodeEngagementChannel" + index}>								
								<a href={`/channel?id=${data.channelId}`} className="detail-link" data-testid={"channelLink"}>{data.channelTitle}</a>
							</td>
							<td data-testid={"episodeEngagementTitle" + index} key={"episodeEngagementTitle" + index}>
								<a href={`/episode?id=${data.episodeId}`} className="detail-link" data-testid={"episodeLink"}>{data.episodeTitle}</a>
							</td>
							<td data-testid={"episodeEngagementListened" + index} key={"episodeEngagementListened" + index}>
								<div className="">
									<input className="form-check-input" type="checkbox"
										id={"listenedId" + index} name={"listenedId" + index}
										checked={!!data.isListened}
										disabled={!canEditEngagement || pendingMeta.has(buildKey(data.episodeId, "isListened"))}
										onChange={(e) => handleToggleEngagement(index, "isListened", e.target.checked)} />
								</div>
							</td>
							{title != "Front" && <>
								<td data-testid={"episodeEngagementFavorite" + index} key={"episodeEngagementFavorite" + index}>
									<div className="">
										<input className="form-check-input" type="checkbox"
											id={"favoriteId" + index} name={"favoriteId" + index}
											checked={!!data.isFavourite}
											disabled={!canEditEngagement || pendingMeta.has(buildKey(data.episodeId, "isFavourite"))}
											onChange={(e) => handleToggleEngagement(index, "isFavourite", e.target.checked)} />
									</div>
								</td>
								<td data-testid={"episodeEngagementJournal" + index} key={"episodeEngagementJournal" + index}>
									<div className="">
										<input className="form-check-input" type="checkbox"
											id={"journalId" + index} name={"journalId" + index}
											checked={!!data.isJournal} disabled readOnly />
									</div>
								</td>
								<td data-testid={"episodeEngagementProgress" + index} key={"episodeEngagementProgress" + index}>{data.progress}.00</td></>}
						</tr>
					)}
					{showModal &&
						<tr>
							<td colSpan={7} style={{ verticalAlign: "middle" }}>
								<DABInlineLoading />
							</td>
						</tr>
					}
					{!showModal && episodeEngageList.length <= 0 &&
						<tr>
							<td colSpan={7} style={{ verticalAlign: "middle" }}>
								No Data Found
							</td>
						</tr>
					}
				</tbody>
			</table>
			{title != "Front" &&
				<Row>
					<Col lg="6">
					</Col>
					<Col lg="6">
						<div className="pagination" style={{ float: 'right' }}>
							<ReactPaginate
								previousLabel={'Previous'}
								nextLabel={'Next'}
								breakLabel={'...'}
								pageCount={pageList.length}
								marginPagesDisplayed={2}
								pageRangeDisplayed={5}
								onPageChange={handlePageClick}
								forcePage={currentPageNo}
								containerClassName={'pagination'}
								pageClassName={"page-item"}
								previousClassName={"page-item"}
								breakClassName={"page-item"}
								breakLinkClassName={"page-link"}
								nextClassName={"page-item"}
								pageLinkClassName={"page-link"}
								previousLinkClassName={"page-link"}
								nextLinkClassName={"page-link"}
								activeClassName={'active'}
							/>
						</div>
					</Col>
				</Row>}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { episodeData } = state;
	return {
		episodeData
	};
};

export default connect(mapStateToProps)(EpisodeEngagement);